module.exports = __webpack_public_path__ + "img/exam.c1f6efec.png";